<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <div class="modal-title-exit-btn">
        <h2 class="modal-title">{{ adminText('organizationAll.what_is_organization_type_0a766bc4', 'What is Organization type?') }}</h2>
        <v-btn icon @click="() => $emit('closeModal')">
          <v-icon color="#979797">clear</v-icon>
        </v-btn>
      </div>

      <p class="description">{{ adminText('organizationAll.there_are_three_types_of_organization_that_yo_5db6b451', 'There are three types of organization that you can create:') }}</p>
      <ul>
        <li class="description">
          <strong>{{ adminText('organizationAll.regular_e5876af8', 'Regular:') }}</strong> {{ adminText('organizationAll.suited_for_general_events_manage_event_listin_dd32c2f6', 'Suited for general events. Manage event listings, handle online ticket sales, and work with external ticket sellers.') }}
        </li>
        <li class="description">
          <strong>{{ adminText('organizationAll.theater_ee3162a2', 'Theater:') }}</strong> {{ adminText('organizationAll.specifically_for_theater_performances_manage__a022136e', 'Specifically for theater performances. Manage multiple shows, offer subscriptions and memberships, and handle in-person sales with cash registers.') }}
        </li>
        <li class="description">
          <strong>{{ adminText('organizationAll.sport_organization_1276ac18', 'Sport organization:') }}</strong> {{ adminText('organizationAll.designed_for_sports_events_sell_tickets_annua_2faedb25', 'Designed for sports events. Sell tickets, annual subscriptions, memberships, and fan merchandise.') }}
        </li>
      </ul>

      <main-button
        depressed
        :text="adminText('organizationAll.understand_1bc5d6c2', 'Understand')"
        class="understand-button"
        @click="$emit('closeModal')"
      />
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

export default {
  mixins: [OrganizationLocalization],
  name: 'organization-type-description-modal',
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 24.3125rem;
  padding: 2rem;
  border-radius: 4px;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}

.modal-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}

.description {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 0;
}

.understand-button {
  width: 100%;
  margin: 2rem 0 0.5rem 0;
}

.v-input__icon {
  margin-right: 0.75rem;
}

.modal-title-exit-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
</style>
